import { baseApi } from '@shared/api/baseApi'
import type {
  ResetStoryViewsResponse,
  StoriesResponse,
  StoryViewResponse,
} from '../types'
import type { StoryEvent, TrackEventsResponse } from '../analytics'

/** Максимум событий в одном батче (ограничение бэка). */
const MAX_EVENTS_PER_BATCH = 50

/** GET /api/stories/list — лента историй (бэк отдаёт до 10 по приоритету). */
export const getStoriesList = async (
  limit?: number,
): Promise<StoriesResponse> => {
  const { data } = await baseApi.get<StoriesResponse>('/api/stories/list', {
    params: limit != null ? { limit } : undefined,
  })
  return data
}

/** POST /api/stories/view — отметить слайд просмотренным, вернуть прогресс истории. */
export const markSlideViewed = async (
  slideId: number,
): Promise<StoryViewResponse> => {
  const { data } = await baseApi.post<StoryViewResponse>('/api/stories/view', {
    slide_id: slideId,
  })
  return data
}

/**
 * POST /api/stories/reset-views — сбросить просмотры историй.
 * Отладочный метод: нужен, чтобы прогонять сценарии на непросмотренной ленте.
 */
export const resetStoryViews = async (): Promise<ResetStoryViewsResponse> => {
  const { data } = await baseApi.post<ResetStoryViewsResponse>(
    '/api/stories/reset-views',
  )
  return data
}

/** POST /api/track/events — отправить один батч событий (≤ 50, не пустой). */
export const trackEvents = async (
  events: StoryEvent[],
): Promise<TrackEventsResponse | null> => {
  if (events.length === 0) return null
  const { data } = await baseApi.post<TrackEventsResponse>('/api/track/events', {
    events,
  })
  return data
}

/**
 * Отправить события пачками по ≤ 50 (fire-and-forget). Ошибки не всплывают —
 * аналитика не должна ломать UX.
 */
export const sendEventsBatched = (events: StoryEvent[]): void => {
  for (let i = 0; i < events.length; i += MAX_EVENTS_PER_BATCH) {
    const chunk = events.slice(i, i + MAX_EVENTS_PER_BATCH)
    trackEvents(chunk).catch(() => {})
  }
}
